// Is also used to Order the departments
export enum DEPARTMENTS {
    MANAGEMENT = 'Geschäftsführung',
    SALES = 'Verkauf & Beratung',
    SERVICE = 'Service & Werkstatt',
    PARTS = 'Teiledienst',
    ORGA = 'Organisation & Weiteres',
}
